import { getBrand } from '~utils/brand-provider'

import austrian from './austrian/config.js'
import brussels from './brussels/config.js'
import swiss from './swiss/config.js'
import lufthansa from './lufthansa/config.js'
import discover from './discover/config'

const brandConfig = {
  austrian,
  brussels,
  swiss,
  lufthansa,
  discover,
}

const getConfig = () => brandConfig[getBrand()]

export default getConfig
